import propertyUtils from '@/services/property/property.utils.js';

const typeOfSelectedMetricValues = {
  isCommercial: {
    '01': 'RentableArea', // $/SF of RA
    '02': 'GBA', // $/SF of GBA
    '03': '', // Whole $
    '04': 'IncomeEffectiveGrossIncome', // % of EGI
  },
  isMultifamily: {
    '01': 'RentableArea', // $/SF of RA
    '02': 'NoofUnits', // $/Unit
    '03': '', // Whole $
    '04': 'IncomeEffectiveGrossIncome', // % of EGI
  },
};

export default {
  getFiltersIncomeExpenses(filtersStructure, dynamicFiltersListParamList) {
    const propertyTypeListFilter = filtersStructure.Filters[0].Filters?.find(({ Field }) => Field.MetricKey === 'PropertyTypeList');
    // const isMultifamily = propertyUtils.isMultifamilyIncomeExpensesType(propertyTypeListFilter);
    const isCommercial = propertyUtils.isCommercialIncomeExpensesType(propertyTypeListFilter?.Values[0]);

    const metricIncomeExpensesFilter = filtersStructure.Filters[0].Filters?.filter((filter) => filter?.Field?.MetricKey?.includes('MetricIncomeExpenses'));

    if (!dynamicFiltersListParamList.some(({ ValueCode }) => ValueCode.includes('IncomeExpenses.'))) {
      dynamicFiltersListParamList.forEach((comboOption) => {
        comboOption.ValueCode = `IncomeExpenses.${comboOption.ValueCode}`;
      });
    }

    const incomeExpensesFiltersLook = filtersStructure.Filters[0].Filters.filter((a) => dynamicFiltersListParamList.find((e) => e.ValueCode.includes(a.Field.MetricKey)));

    if (metricIncomeExpensesFilter.length && metricIncomeExpensesFilter[0].Values[0] !== '03') {
      if (isCommercial) {
        return incomeExpensesFiltersLook.forEach((filter) => {
          return (filter.Field.MetricKey = `@DIV|${filter.Field.MetricKey}|${typeOfSelectedMetricValues.isCommercial[metricIncomeExpensesFilter[0].Values[0]]}`);
        });
      } else {
        return incomeExpensesFiltersLook.forEach((filter) => {
          return (filter.Field.MetricKey = `@DIV|${filter.Field.MetricKey}|${typeOfSelectedMetricValues.isMultifamily[metricIncomeExpensesFilter[0].Values[0]]}`);
        });
      }
    }

    return;
  },
};
